import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { TreeModule } from '@ali-hm/angular-tree-component';
import { LocalizeRouterModule } from 'localize-router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DayjsModule } from '$shared/pipes/dayjs.module';
import { OfficesMapModule } from './offices-map/offices-map.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    TranslateModule,
    LocalizeRouterModule,
    NgSelectModule,
    TooltipModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    TabsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TypeaheadModule,
    BsDropdownModule,
    ScrollingModule,
    NgxIntlTelInputModule,
    InlineSVGModule,
    TreeModule,
    OfficesMapModule,
    NgScrollbarModule,
    DayjsModule,
  ],
  exports: [
    RouterModule,
    FontAwesomeModule,
    TranslateModule,
    LocalizeRouterModule,
    NgSelectModule,
    TooltipModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    TabsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TypeaheadModule,
    BsDropdownModule,
    ScrollingModule,
    NgxIntlTelInputModule,
    InlineSVGModule,
    TreeModule,
    DayjsModule,
    OfficesMapModule,
    NgScrollbarModule,
  ],
})
export class ModulesModule {}
